import React from 'react';
import PropTypes from 'prop-types';

import AddressesTable from './addresses/AddressesTable';

const ContactInformationSection = ({ className, showBadAddress }) => {
  return (
    <div className={className}>
      <AddressesTable
        className="vads-u-margin-bottom--6"
        showBadAddress={showBadAddress}
      />
    </div>
  );
};

ContactInformationSection.propTypes = {
  className: PropTypes.string,
  showBadAddress: PropTypes.bool,
};

export default ContactInformationSection;
